<template>
  <section class="max-w-4xl px-4 py-16 mx-auto">
    <h1 class="mb-8 text-3xl font-bold text-gray-900 dark:text-gray-100">
      {{ $t("privacy.title") }}
    </h1>

    <div class="space-y-8 text-justify text-gray-800 dark:text-gray-300">
      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          {{ $t("privacy.introTitle") }}
        </h2>
        <p>{{ $t("privacy.introText") }}</p>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          1. {{ $t("privacy.dataCollected.title") }}
        </h2>
        <ul class="space-y-1 list-disc list-inside">
          <li>{{ $t("privacy.dataCollected.item1") }}</li>
          <li>{{ $t("privacy.dataCollected.item2") }}</li>
          <li>{{ $t("privacy.dataCollected.item3") }}</li>
        </ul>
        <p class="mt-2">{{ $t("privacy.dataCollected.note") }}</p>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          2. {{ $t("privacy.dataUsage.title") }}
        </h2>
        <ul class="space-y-1 list-disc list-inside">
          <li>{{ $t("privacy.dataUsage.item1") }}</li>
          <li>{{ $t("privacy.dataUsage.item2") }}</li>
          <li>{{ $t("privacy.dataUsage.item3") }}</li>
        </ul>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          3. {{ $t("privacy.dataSharing.title") }}
        </h2>
        <ul class="space-y-1 list-disc list-inside">
          <li>{{ $t("privacy.dataSharing.item1") }}</li>
          <li>{{ $t("privacy.dataSharing.item2") }}</li>
        </ul>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          4. {{ $t("privacy.dataSecurity.title") }}
        </h2>
        <p>{{ $t("privacy.dataSecurity.text") }}</p>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          5. {{ $t("privacy.userRights.title") }}
        </h2>
        <ul class="space-y-1 list-disc list-inside">
          <li>{{ $t("privacy.userRights.item1") }}</li>
          <li>{{ $t("privacy.userRights.item2") }}</li>
          <li>{{ $t("privacy.userRights.item3") }}</li>
          <li>{{ $t("privacy.userRights.item4") }}</li>
          <li>{{ $t("privacy.userRights.item5") }}</li>
        </ul>
        <p class="mt-2">{{ $t("privacy.userRights.contact") }}</p>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          6. {{ $t("privacy.cookies.title") }}
        </h2>
        <p>{{ $t("privacy.cookies.text") }}</p>
      </div>

      <div>
        <h2 class="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          7. {{ $t("privacy.changes.title") }}
        </h2>
        <p>{{ $t("privacy.changes.text") }}</p>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const i18n = useI18n();
useSeoMeta({
  title: i18n.t("legalKeys.privacyPolicy"),
});
</script>
